module.exports = __webpack_public_path__ + "static/img/ls38.c184288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls38.png
// module id = L3tb
// module chunks = 12